export default __webpack_public_path__ + "static/media/Jcb.b6e6bf21.svg";